<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <!-- <el-col :span="24">
          <el-form-item label="选择场所类型" prop="type">
            <el-select v-model="form_data.type" placeholder="全部" clearable>
              <el-option v-for="(item, index) in PLACE_STATE" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="状态" prop="is_active">
            <el-switch v-model="form_data.is_active" :active-value="1" :inactive-value="0"  active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="用于消防柜" prop="is_registered">
            <el-switch v-model="form_data.is_registered" :active-value="1" :inactive-value="0"  active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="循环使用" prop="is_recycle">
            <el-switch v-model="form_data.is_recycle" :active-value="1" :inactive-value="0"  active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="选择分类" prop="material_type_id">
            <el-cascader v-model="form_data.material_type_id" :options="material_type_node" :props="{ checkStrictly: true }" @change="changeMaterialType(form_data.material_type_id)" clearable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="选择规格" prop="material_name">
                <el-select v-model="form_data.material_specification_id" placeholder="选择规格" clearable>
                    <el-option v-for="item in specification_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="代码" prop="material_code">
            <el-input v-model="form_data.material_code" autocomplete="off" placeholder="请输入代码"></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="缩写" prop="abbreviation">
            <el-input v-model="form_data.abbreviation" autocomplete="off" placeholder="请输入缩写"></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="24">
            <el-form-item label="库存单位" prop="material_name">
                <el-select v-model="form_data.sku_id" placeholder="选择库存单位" clearable>
                  <el-option v-for="item in material_sku_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
        </el-col>
        
        <el-col :span="12">
            <el-form-item label="报废年限" prop="material_name">
                <el-select v-model="form_data.material_retirement_life_id" placeholder="选择报废年限" clearable>
                <el-option v-for="item in material_retirement_life_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
        </el-col>
        
        <el-col :span="12">
            <el-form-item label="检查周期" prop="material_name">
                <el-select v-model="form_data.material_inspect_interval_id" placeholder="选择检查周期" clearable>
                <el-option v-for="item in material_inspect_interval_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="提前检查天数" prop="check_before_days">
            <el-input v-model="form_data.check_before_days" autocomplete="off" placeholder="请输入提前检查天数"></el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="滞后检查天数" prop="sku_id">
            <el-input v-model="form_data.check_after_days" autocomplete="off" placeholder="请输入滞后检查天数"></el-input>
          </el-form-item>
        </el-col>
        
        <!-- <el-col :span="24">
          <el-form-item label="中类" prop="name" v-if="form_data.type_level == 2">
            <el-input type="textarea" v-model="form_data.name" autocomplete="off" :rows="6" maxlength="250" placeholder="请输入中类"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="小类" prop="name" v-if="form_data.type_level == 3">
            <el-input type="textarea" v-model="form_data.name" autocomplete="off" :rows="6" maxlength="250" placeholder="请输入小类"></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24">
          <el-form-item label="标准检查等级" prop="danger_lavel" v-if="form_data.grade == 3">
            <el-radio-group v-model="form_data.danger_lavel">
              <el-radio :label="parseInt(index)" v-for="(item,index) in LEVEL" :key="index">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import { MATERIAL_LEVEL, PLACE_STATE, STATE_NAMES, LEVEL } from '../public/basis.js';
export default {
  name: 'l-material-type-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    }
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中

      //资源类型
      MATERIAL_LEVEL: MATERIAL_LEVEL,
      PLACE_STATE: PLACE_STATE,
      STATE_NAMES: STATE_NAMES,
      LEVEL: LEVEL,
      sel_material_type_id: 2,
      specification_list: [],
      material_type_node: [],
      material_retirement_life_list: [],
      material_inspect_interval_list: [],
      material_sku_list: [],
      //表单数据
      form_data: {
        //场所类型 公共场所 
        // place_type: 4,
        name: '',
        is_active: 1,
        is_registered: 1,
        id:'',
        pid: [],
        // fraction: 0,
        // inspection_method: '',
        // danger_lavel: ''
      },
      //表单验证规则
      rules: {
        id: [
          {type: 'number', required: true, message: '编码不能为空', trigger: 'change', transform: (value) => Number(value)}
        ],
        name: [
          { required: true, message: '名称不能为空', trigger: 'change' }
        ],
        material_type_id: [
          { required: true, message: '分类不能为空', trigger: 'change' }
        ],
        is_active: [
          { required: true, message: '状态不能为空', trigger: 'change' }
        ],

      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },

    //获取数据
    getData() {
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`materialManage_getEditData`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          this.material_type_node = ret.material_type_node;
          this.specification_list = ret.specification_list;
          this.material_sku_list = ret.material_sku_list;
          this.material_retirement_life_list = ret.material_retirement_life_list;
          this.material_inspect_interval_list = ret.material_inspect_interval_list;
        }).finally(() => {
          this.loading = false;
        });

      } else {
        this.loading = true;
        this.$_invoke(`materialManage_getAddData`).then((ret) => {
          this.material_type_node = ret.material_type_node;
          this.material_sku_list = ret.material_sku_list;
          this.material_retirement_life_list = ret.material_retirement_life_list;
          this.material_inspect_interval_list = ret.material_inspect_interval_list;
        }).finally(() => {
          this.loading = false;
        });  
          
        // this.form_data.use_type = this.$props.useType
      }
    },

    changeMaterialType(typeid) {
        console.log(typeid);
        let sel_type_id = typeid
        if (typeof sel_type_id != "number") {
          const pid_len = sel_type_id.length;
          sel_type_id = sel_type_id[pid_len - 1];
        }
        this.sel_material_type_id = sel_type_id;
        this.loading = true;
        this.$_invoke(`materialManage_getSpecificationList`, {sel_type_id }).then((ret) => {
            this.specification_list = ret.specification_list;       
        }).finally(() => {
          this.loading = false;
        });
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          // if (typeof this.form_data.material_type_id != "number" && this.form_data.material_type_id.length != 0) {
          //   const pid_len = this.form_data.pid.length;
          //   this.form_data.material_type_id = this.form_data.material_type_id[pid_len - 1];
          // } else {
          //     this.form_data.material_type_id = 2;
          // }
          
          this.form_data.material_type_id = this.sel_material_type_id;
          console.log(this.form_data.material_type_id);
          
          this.submitting = true;
          if (!this.hasId) {//添加是·
            this.$_invoke('materialManage_save',
              this.form_data).then(() => {
                this.$_msg.success('添加成功');
                this.$emit('on-success');
              }).finally(() => {
                this.submitting = false;
              })
          } else {//修改
            this.$_invoke(`materialManage_update`, {
              id: this.$props.id,
              ...this.form_data
            }).then(() => {
              this.$_msg.success('修改成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
  },
}
</script>